var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "w-card",
        { attrs: { "max-width": "960" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct(_vm.add ? "add-column" : "edit-column"))),
          ]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            [
              _c(
                "w-row",
                { attrs: { stretch: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { stretch: "" } },
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-model-column-select", {
                                attrs: {
                                  model: _vm.browse.type,
                                  browse: _vm.browse,
                                },
                                on: {
                                  "prop-name": _vm.onPropName,
                                  inputLabel: function ($event) {
                                    return _vm.onInput($event)
                                  },
                                },
                                model: {
                                  value: _vm.selectedPropName,
                                  callback: function ($$v) {
                                    _vm.selectedPropName = $$v
                                  },
                                  expression: "selectedPropName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { stretch: "" } },
                        [
                          _vm.isJson
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("app-browse-column-select-json-property", {
                                    attrs: {
                                      browse: _vm.browse,
                                      fancy: "",
                                      column: _vm.selectedPropName,
                                    },
                                    model: {
                                      value: _vm.column.JsonProperty,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.column,
                                          "JsonProperty",
                                          $$v
                                        )
                                      },
                                      expression: "column.JsonProperty",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("column-name"),
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.column.Name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.column, "Name", $$v)
                                  },
                                  expression: "column.Name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("column-width"),
                                },
                                model: {
                                  value: _vm.columnWidth,
                                  callback: function ($$v) {
                                    _vm.columnWidth = $$v
                                  },
                                  expression: "columnWidth",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.isDecimalSettingAllowed
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      decimals: 0,
                                      disabled: _vm.decimals == null,
                                      icon: "times",
                                      fancy: "",
                                      label: _vm.$ct("decimals"),
                                      max: 20,
                                      min: 0,
                                    },
                                    on: {
                                      "icon-click": function ($event) {
                                        _vm.decimals = null
                                      },
                                    },
                                    model: {
                                      value: _vm.decimals,
                                      callback: function ($$v) {
                                        _vm.decimals = $$v
                                      },
                                      expression: "decimals",
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: _vm.decimals === null,
                                      label: _vm.$ct("enable-decimals"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.toggleDecimals($event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-select", {
                                attrs: {
                                  items: _vm.alignItems,
                                  fancy: "",
                                  label: _vm.$ct("alignment"),
                                },
                                model: {
                                  value: _vm.alignment,
                                  callback: function ($$v) {
                                    _vm.alignment = $$v
                                  },
                                  expression: "alignment",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.isBoolean
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-radio", {
                                    attrs: {
                                      name: "custom-boolean",
                                      checked: _vm.customBoolean.mode == null,
                                      label: _vm.$ct("use-default-text"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.disableCustomBoolean()
                                      },
                                    },
                                  }),
                                  _c("w-radio", {
                                    attrs: {
                                      name: "custom-boolean",
                                      checked:
                                        _vm.customBoolean.mode == "icons",
                                      label: _vm.$ct("use-icons"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.setCustomBooleanIcons()
                                      },
                                    },
                                  }),
                                  _c("w-radio", {
                                    attrs: {
                                      name: "custom-boolean",
                                      checked: _vm.customBoolean.mode == "text",
                                      label: _vm.$ct("use-custom-text"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.setCustomBooleanText()
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isBoolean && _vm.customBoolean.mode == "text"
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("text-if-true"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.customBoolean.textTrue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customBoolean,
                                          "textTrue",
                                          $$v
                                        )
                                      },
                                      expression: "customBoolean.textTrue",
                                    },
                                  }),
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("text-if-false"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.customBoolean.textFalse,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customBoolean,
                                          "textFalse",
                                          $$v
                                        )
                                      },
                                      expression: "customBoolean.textFalse",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isBoolean && _vm.customBoolean.mode == "icons"
                            ? _c(
                                "app-column-edit-custom-boolean-icon-advanced-settings",
                                {
                                  attrs: {
                                    column: _vm.customBoolean.booleanSettings,
                                  },
                                }
                              )
                            : _vm._e(),
                          _vm.hasClickAction
                            ? [
                                _c(
                                  "w-col",
                                  { attrs: { xs: "12" } },
                                  [
                                    _c("w-checkbox", {
                                      attrs: {
                                        label: _vm.enableClickActionText,
                                      },
                                      model: {
                                        value: _vm.column.EnableClickAction,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.column,
                                            "EnableClickAction",
                                            $$v
                                          )
                                        },
                                        expression: "column.EnableClickAction",
                                      },
                                    }),
                                    _c("w-checkbox", {
                                      attrs: {
                                        disabled: !_vm.column.EnableClickAction,
                                        label: _vm.$ct(
                                          "click-action-on-double-click"
                                        ),
                                      },
                                      model: {
                                        value:
                                          _vm.column.ClickActionOnDoubleClick,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.column,
                                            "ClickActionOnDoubleClick",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "column.ClickActionOnDoubleClick",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("app-column-edit-click-action-options", {
                                  attrs: { field: _vm.selectedProp },
                                  model: {
                                    value: _vm.column,
                                    callback: function ($$v) {
                                      _vm.column = $$v
                                    },
                                    expression: "column",
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }